var _line, _g, _line2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 24,
    viewBox: "0 0 444 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.0422363,
    y1: 11.502,
    x2: 200.042,
    y2: 11.502,
    stroke: "url(#paint0_linear_122_447)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.29 0.00195312H217.535C218.514 0.00418141 219.453 0.394135 220.147 1.0866C220.84 1.77906 221.23 2.71772 221.234 3.69745V11.1924H213.593V3.69745C213.596 2.71809 213.987 1.77968 214.679 1.08724C215.372 0.394806 216.31 0.00462835 217.29 0.00195312Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.042 7.66683V7.43359C210.044 6.49959 210.416 5.60438 211.076 4.9437C211.736 4.28303 212.631 3.91064 213.565 3.90796L221.234 11.1925H213.565C212.631 11.1898 211.736 10.8174 211.076 10.1567C210.416 9.49604 210.044 8.60083 210.042 7.66683Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.71 0.00195312H226.465C225.485 0.00440438 224.546 0.394457 223.853 1.08689C223.16 1.77933 222.77 2.71786 222.766 3.69745V11.1924H230.407V3.69745C230.404 2.71809 230.013 1.77968 229.321 1.08724C228.628 0.394806 227.69 0.00462835 226.71 0.00195312Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.958 7.66683V7.43359C233.956 6.49944 233.584 5.60411 232.923 4.94341C232.263 4.28271 231.368 3.91041 230.434 3.90796L222.766 11.1925H230.434C231.368 11.19 232.263 10.8177 232.923 10.157C233.584 9.49631 233.956 8.60098 233.958 7.66683Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.29 23.9191H217.535C218.514 23.9164 219.453 23.5262 220.146 22.8336C220.839 22.1411 221.23 21.2025 221.234 20.2227V12.7278H213.593V20.2227C213.596 21.2021 213.987 22.1404 214.679 22.833C215.372 23.5255 216.31 23.9159 217.29 23.9191Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.042 16.2517V16.4867C210.045 17.4204 210.417 18.3151 211.077 18.9755C211.737 19.6358 212.632 20.0079 213.565 20.0106L221.234 12.7278H213.565C212.632 12.7305 211.737 13.1026 211.077 13.7629C210.417 14.4232 210.045 15.318 210.042 16.2517Z",
    fill: "#295F98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.71 23.9191H226.465C225.485 23.9162 224.546 23.5258 223.853 22.8333C223.161 22.1408 222.77 21.2023 222.766 20.2227V12.7278H230.407V20.2227C230.404 21.2021 230.013 22.1404 229.321 22.833C228.628 23.5255 227.69 23.9159 226.71 23.9191Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.958 16.2517V16.4867C233.955 17.4205 233.583 18.3154 232.923 18.9757C232.263 19.6361 231.368 20.0081 230.434 20.0106L222.766 12.7278H230.434C231.368 12.7302 232.263 13.1023 232.923 13.7626C233.583 14.423 233.955 15.3179 233.958 16.2517Z",
    fill: "#295F98"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 243.958,
    y1: 11.502,
    x2: 443.958,
    y2: 11.502,
    stroke: "url(#paint1_linear_122_447)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_447",
    x1: 0.0422363,
    y1: 12.502,
    x2: 200.042,
    y2: 12.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A7FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_122_447",
    x1: 243.958,
    y1: 12.502,
    x2: 443.958,
    y2: 12.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39A7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9155,
    height: 24,
    fill: "white",
    transform: "translate(210.042 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadingLines);
export default __webpack_public_path__ + "static/media/heading-lines.980f1e720e8efd9f366116c7ba48dc8c.svg";
export { ForwardRef as ReactComponent };